import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Close } from "@mui/icons-material";
import { useAlenSchedulingContext } from "../AlenSchedulingContext";
import FrequencySelector from "./FrequencySelector";
import ActionSelector from "./ActionSelector";
import { ScheduleDto } from "../types";

function NewScheduleDetailsDialog({
  open,
  onClose,
  onBack,
  onSave,
}: {
  open: boolean;
  onClose: () => void;
  onBack: () => void;
  onSave: (schedule: ScheduleDto) => void;
}) {
  const handleClose = (
    _event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    if (reason && reason === "backdropClick") return;
    onBack();
  };

  const { setNewScheduling, newScheduling, isScheduleValid } =
    useAlenSchedulingContext();

  return (
    <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
      <DialogTitle>Schedule Details</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <Close />
      </IconButton>
      <DialogContent>
        <Stack direction="column" gap="1rem" alignItems="flex-start">
          <Stack paddingY=".5rem">
            <TextField
              value={newScheduling.schedulerName}
              label="Schedule Name"
              onChange={(e) => {
                setNewScheduling((prev) => ({
                  ...prev,
                  schedulerName: e.target.value,
                }));
              }}
            />
          </Stack>
          <Typography variant="subtitle1">Select Schedule</Typography>
          <FrequencySelector />
          <Typography variant="subtitle1">Select Action</Typography>
          <ActionSelector />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack} color="danger">
          Back
        </Button>
        <Button
          disabled={!isScheduleValid}
          onClick={() => onSave(newScheduling)}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewScheduleDetailsDialog;
